
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.805 11.188L4.039 10H.164V8.96h4.078l.516-2.577-4.594-1.61V3.68l5.508-1.93.336-1.672h.914l-.266 1.328L9.79.313v1.171L6.422 2.57l-.617 3.118 3.984 1.28v1.173L5.61 6.68l-.453 2.28H9.79V10H4.953l-.234 1.188h-.914zm1.14-5.774l.508-2.531-4.18 1.344 3.672 1.187z","fill":"currentColor"}})])
          )
        }
      }
    